import React, { Component } from 'react';


import NumberFormat from 'react-number-format';
import {transactionID, clientInfo} from '../../../services/helpers';
import axios from 'axios';
import Swal from 'sweetalert2';




class ChooseCreditCard extends Component {

    constructor(props) {
        super(props);

        axios.defaults.headers.common['Authorization'] = "Bearer " + clientInfo().accessToken;
        axios.defaults.headers.common['Content-Type'] = "application/json";

        this.state = {
            
            creditCardList: []
        }
    }

    getCreditCardFlag(flag) {
        flag = ('' + flag).toLocaleLowerCase();
        return `images/payments/${flag}.svg`;
    }

    getCreditCardList = async () => {

        this.props.handleLoading(1);

        axios.post('https://www.pagtel.com.br/Hub360Correios/v2/GetCard', {
            transactionId: transactionID('ACF'),
            MSISDN: clientInfo().number
        }).then((response) => {
            this.setState({ creditCardList: response.data.cardList, loading: 0 });
        });

        this.props.handleLoading(0);

    }

    componentDidMount = async () => {
        await this.getCreditCardList();
    }

    render() {

        const {creditCardList} = this.state;

        return (

            <div className="choose-creditcard">
                <h2>Selecione o cartão de crédito</h2>
                <ul className="select-payment-method">

                    {
                        creditCardList.length === 0 &&

                        <li>
                            <h3>Nenhum cartão cadastrado!</h3>
                        </li>
                    }

                    {
                        creditCardList.map((creditCard, key) => {
                            return (
                                <li onClick={() => { this.props.handlePayment(creditCard) }} key={key}>
                                    <div className="img-select-method">
                                        <img src={require(`../../../images/payments/${creditCard.flag.toLocaleLowerCase()}.svg`)} />
                                    </div>
                                    <div>
                                        <h4>Cartão {creditCard.flag}</h4>
                                        <p>Final {creditCard.digFour}</p>
                                    </div>
                                    <div className="arrow-icon" href="#" ></div>
                                </li>
                            );

                        })
                    }
                </ul>
                <p className="choose-number-new-number cursor-pointer" onClick={() => { this.props.setPaymentType('C') }}><i className="choose-number-plan-icon icon-plus"></i> Adicionar novo cartão</p>
            </div>

        );
    }

}

export default ChooseCreditCard